import { Link } from 'react-router-dom';

const AllPages = () => {
  return (
    <>
      <ul>
        <li>
          <Link to="/messageThreads">MessageThreads</Link>
        </li>
        <li>
          <Link to="/messaging/1">Messaging</Link>
        </li>
        <li>
          <Link to="/findProperties?zip=95118">Find Properties</Link>
        </li>
        <li>
          <Link to="/myProperties">My Properties</Link>
        </li>
        <li>
          <Link to="/signup">Signup</Link>
        </li>
      </ul>
    </>
  );
};

export default AllPages;
